import Model, { fields } from '@thinknimble/tn-models'
import { objectToCamelCase } from '@thinknimble/tn-utils'

export default class BaseContentfulModel extends Model {
  static contentfulObjectType = new fields.CharField()
  static contentfulSysType = new fields.CharField()
  static createdAt = new fields.CharField()
  static updatedAt = new fields.CharField()
  static id = new fields.CharField()
}

export class ContentfulFileType extends Model {
  static contentType = new fields.CharField()
  static details = new fields.CharField()
  static fileName = new fields.CharField()
  static url = new fields.CharField()
  static fromAPI(json) {
    let fileUrl = json.url
    fileUrl = fileUrl ? fileUrl.replace(/^(\/\/)/, 'https://') : null
    return new ContentfulFileType(objectToCamelCase({ ...json, url: fileUrl }))
  }
}
export class AssetBaseContentful extends BaseContentfulModel {
  static file = new fields.ModelField({ ModelClass: ContentfulFileType })
}
